module.exports = __webpack_public_path__ + "img/a30c2c3.jpg";